export default function ForgotPassword() {
    return (
        <>
            Login
        </>
    )
}